import Immutable from 'immutable';
import { createSelector } from 'reselect';

// state selectors
export const allBlocksSelector = (state) => state.Blocks;
const allPagesSelector = (state) => state.Pages.get('byPath');

// Helper methods
export const getBlockById = (blocks, blockId) => blocks.get(`block-${blockId}`);

// selectors
export const getPageBlocks = createSelector(
  [allPagesSelector, allBlocksSelector],
  (allPages, allBlocks) => {
    return allPages.reduce((current, page) => {
      const blocks = page
        .get('blockIndexes', Immutable.List())
        .map((blockId) => {
          let block = getBlockById(allBlocks, blockId);

          // add any extra block data from the data loaded with the apge
          const queryParams = page.getIn(['blockQueryParams', blockId]);

          if (queryParams) {
            block = block?.set('queryParams', queryParams);
          }

          return block;
        });

      return current.set(page.get('path'), blocks);
    }, Immutable.Map());
  }
);

export const selectBlockByBlockId = (blockId) =>
  createSelector(allBlocksSelector, (blocks) => {
    const block = blocks.get(`block-${blockId}`, null);
    return block ? block.toJS() : null;
  });

export const selectBlocksByPagePath = (pagePath) =>
  createSelector(getPageBlocks, (blocks) => {
    return blocks.get(pagePath);
  });
